import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck  from '../model/ModelCheck';

/**
 * 
 * @param {ModelCheck} props 
 * @returns 
 */ 
const CardResult = (props) => {
    /** @type {ModelCheck} */
    const check = props.data

    return (
        <div className={'card card-result center ' + check.checkStatusClassName}> 
            <h1 className='background-status' style={{fontSize: check.backgroundNameFontSize}}>{check.checkBackgroundStatusName}</h1>
            <p>{check.checkStatusName}</p>
        </div>
    )
}

export default CardResult